<script>
  import { onMount } from 'svelte';
  import Button from '@components/Button.svelte';

  import CreateAccountModal from '@app-components/modal/CreateAccountModal.svelte';
  import { goto } from '$app/navigation';
  import { getCurrentUserStore } from '@stores/current_user';
  import AppInviteAjax from '@ajax/app_invite';

  export let mobile = false;
  export let groupId;
  export let fetchInviteCodeAutomaticallyUser = null;

  let showCreateAccountModal = false;
  let currentUser = getCurrentUserStore('default');
  let inviteCode;

  let fetchInviteCodeAutomatically = async function () {
    let resp = await AppInviteAjax.skipInviteCode(fetchInviteCodeAutomaticallyUser.id);
    inviteCode = resp && resp.code;
  };

  function showModalOrRedirect() {
    if (mobile && inviteCode) {
      location.href = `/i/${inviteCode}`;
    } else {
      showCreateAccountModal = true;
    }
  }

  onMount(() => {
    let unsub = currentUser.subscribe((x) => (currentUser = x));

    if (mobile && fetchInviteCodeAutomaticallyUser) {
      fetchInviteCodeAutomatically();
    }

    return () => {
      unsub();
    };
  });
</script>

<style style="text/scss" lang="scss">
  .visitor-container {
    width: 100%;
    height: 64px;
    overflow: hidden;
    position: fixed;
    top: 0px;
    z-index: 10;
    background-size: cover;
    background: linear-gradient(108.16deg, #fcf0e3 24.7%, #eae4ff 83.56%);
  }

  /* Add spacing below banner to prevent navbar overlap */
  .visitor-spacer {
    height: 64px;
    width: 100%;
  }

  .text-button-container {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;

    .text-container {
      display: flex;
      flex: 1;
      padding-left: 45px;

      .main-text {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        opacity: 0.8;
      }

      .sub-text {
        opacity: 0.8;
        color: #665e83;
        font-size: 14px;
        line-height: 18px;
        margin-left: 8px;
        margin-top: 1px;
      }
    }

    .button-container {
      flex-shrink: 0;
      margin-top: -3px;
      padding-right: 45px;

      :global(button) {
        border-radius: 999px !important;
      }

      :global(button > span) {
        margin-top: -1px;
      }
    }
  }

  @media only screen and (max-width: 1280px) {
    .sub-text {
      display: none;
    }
  }

  @media only screen and (max-width: 680px) {
    .visitor-spacer {
      height: 72px;
      width: 100%;
    }

    .visitor-container {
      height: 60px !important;
      padding-top: 6px !important;
      background: #f5f3fc !important;
    }

    .text-button-container {
      flex-direction: column;
      align-items: flex-start !important;
      padding-left: 30px;
      padding-right: 30px;
    }

    .text-container {
      display: none !important;
      padding-left: 0px !important;
      padding-right: 0px !important;
    }

    .button-container {
      padding-right: 0px !important;
      padding-left: 0px !important;
      margin-top: 5px !important;
      width: 100% !important;

      :global(button) {
        width: 100% !important;
        height: 38px !important;
      }
    }
  }
</style>

{#if showCreateAccountModal}
  <div>
    <CreateAccountModal
      eventDetails={{ trigger_event: 'signup_button', group_base_id: groupId }}
      msgStyle="font-size: 20px;"
      mobile={mobile}
      successCallback={() => {
        goto(`/discover`);
      }}
      beforeDataSend={(data) => {
        data['sign_up_source'] = {
          source: 'visitor-banner',
          group_base_id: groupId,
        };
        return data;
      }}
      showPassword={true}
      msg="Create your free account"
      buttonText="Create account"
      bind:showModal={showCreateAccountModal}
      inviteFlow={true}
      fetchInviteCodeAutomaticallyUserId={fetchInviteCodeAutomaticallyUser && fetchInviteCodeAutomaticallyUser.id} />
  </div>
{/if}

{#if !currentUser || !currentUser.id}
  <div class="visitor-spacer" />
  <div class="visitor-container">
    <div class="text-button-container">
      <div class="text-container">
        <div class="main-text">Benable — create shareable lists of things you recommend!</div>

        <div class="sub-text">
          E.g., products you love, local businesses, travel recs - you can add anything to a Benable list!
        </div>
      </div>

      <div class="button-container">
        <Button
          text="Sign up for free"
          style="width: 155px; height: 40px; border-radius: 12px; box-shadow: none; background: #7A5CFA;"
          on:click={() => showModalOrRedirect()} />
      </div>
    </div>
  </div>
{/if}
